import {
  useQueryClient,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { UserProfile } from "@okta/okta-sdk-nodejs";

import { API_PROFILE_URL } from "constants/apiUrls";

import { QueryKey } from "types/queryKey/queryKey";

import useGetApiClient from "./useGetApiClient";
import { OktaError } from "../types/oktaError/oktaError";

function useUpdateProfileData(): UseMutationResult<
  void,
  OktaError,
  UserProfile
> {
  const apiClient = useGetApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newProfileData: UserProfile) => {
      const response = await apiClient(API_PROFILE_URL, {
        method: "POST",
        body: JSON.stringify(newProfileData),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return Promise.resolve();
      }
    },
    onSuccess: (savedProfileData) => {
      queryClient.setQueryData([QueryKey.Profile], () => savedProfileData);
    },
  });
}

export default useUpdateProfileData;
